import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./PageNotFound.js'))

export default new AsyncPage({
  basicDataRequirements: {
    instance: true,
    session: false
  },
  pageComponent: component
})
